<!--
	COMPONENT APP
-->


<!---------- SCRIPT ---------->

<script lang="ts">

	import { onMount } from "svelte";	
	import { app_version, flyMode, square, deglingos, minitel, english } from './store/store';
	import Header from './components/Header.svelte';
	import Route from './components/router/Route.svelte';
	import Footer from './components/Footer.svelte';
    import { redirection, historyNavigation } from "./js/common";
	// COOKIE - deb
	//import CookieBanner from './components/CookieBanner.svelte';
	// COOKIE - fin
	
	/**
	 * Application d'un style différent selon le numéro du jour
	 * 3 styles => Modulo 3
	 */
	function styling() {
		const today:Date = new Date();
		const modulo_style: number = today.getDate() % 3;
		if (modulo_style == 0) {
			$square = true;
			$deglingos = false;
			$minitel = false;
		} else if (modulo_style == 1) {
			$square = false;
			$deglingos = true;
			$minitel = false;
		} else if (modulo_style == 2) {
			$square = false;
			$deglingos = false;
			$minitel = true;
		}
	}

	onMount(async () => {
		console.log($app_version.app_name + " - version " + $app_version.version);
		redirection();
		styling();
	});

</script>


<!---------- STYLE ---------->

<style lang="scss">

	.body {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-family: 'Montserrat', sans-serif;
		margin: auto;
		padding: 0;
		width: 100%;
		background-color: $color_primary;
		color: $color_primary;
		&__minitel {
			background-color: $color_black;
			color: $color_minitel_green;
			font-family: 'minitel';
			font-weight: 400;
			font-size: larger;
		}
	}

	.contener {
		display: grid;
		grid-template-rows: 500px 1fr;
		grid-template-areas:
			"header"
			"route";
		gap: 4px;
		align-items: center;
		min-height: 100%;
		width: 100%;
		max-width: 100%;
		margin: 0 0 0 0;
		padding: 4px 4px 4px 4px;
		box-sizing: border-box;
		background-color: $color_primary;
		color: $color_primary;
		&__minitel {
			grid-template-rows: 400px 1fr;
			background-color: $color_black;
			color: $color_minitel_green;
		}
	}

	.flyMode {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		background-color: $color_primary;
		color: $color_secondary;
		width: 100%;
		height: 100%;
		position: fixed;
		opacity: 1;
		z-index: 20000;
		transition: opacity 3s;
		padding: 32px 20% 0 20%;
		&__minitel {
			background-color: $color_black;
			color: $color_minitel_green;
		}
		&__images {
			display: flex;
			flex-direction: row;
			justify-content: space-around;
			align-items: center;
			flex-wrap: wrap;
			&__img {
				cursor: pointer;
				padding: 32px 32px 32px 32px;
				height: 30px;
			}
		}
		&--hidden {
			opacity: 0;
			z-index: -20000;
			transition: opacity 3s, z-index 3s;
		}
	}

	@include large {

		.body {
			background-color: $color_white;
			background: linear-gradient(0.25turn, $color_white, $color_primary, $color_white);
			&__minitel {
				background: none;
				background-color: $color_black;
				color: $color_minitel_green;
			}
		}

		.border {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 60%;			
			background-color: $color_primary;
			border-radius: 4px;
			margin: 8px 0 8px 0;
			&--deglingos {
				width: 100%;
				margin: 0 0 0 0;
				border-radius: 0;
			}
			&__minitel {
				background-color: $color_black;
				width:100%;
			}
		}
		.contener {
			grid-template-rows: 500px 1fr;
			grid-template-areas:
			"header"
			"route";
			gap: 8px;
			width: 100%;
			padding: 8px 8px 0 8px;
			&__minitel {
				grid-template-rows: 300px 1fr;
			}
		}
	}

</style>

<!---------- TEMPLATE ---------->
<svelte:window on:popstate|preventDefault={historyNavigation} />
<svelte:head>
	<title>{$app_version.app_name}</title>
</svelte:head>
<div class="body" class:body__minitel={$minitel}>
	<div class="border" class:border--deglingos={$deglingos} class:border__minitel={$minitel}>
		<div class="contener" class:contener__minitel={$minitel}>
			<Header />
			<Route />
		</div>
	</div>
	<div id="divFlyMode" class="{$flyMode === true ? 'flyMode' : 'flyMode flyMode--hidden'}" class:flyMode__minitel={$minitel}>
		<div class="flyMode__images">
			{#if $minitel}
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			{:else}
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			{/if}
		</div>
		{#if $english}
			Be zen and go to the forest!
		{:else}
			Sois zen et va dans la fôret !
		{/if}
		<div class="flyMode__images">
			{#if $minitel}
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			{:else}
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			{/if}
		</div>
		{#if $english}
			Be cool and go to the beach!
		{:else}
			Sois cool et va à la plage !
		{/if}
		<div class="flyMode__images">
			{#if $minitel}
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_lime.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			{:else}
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			<img class="flyMode__images__img" src="../images/icone_wifi_secondary.png" alt="fly mode" on:click={() => $flyMode = !$flyMode}>
			{/if}
		</div>
	</div>
	<Footer />
	<!-- COOKIE - deb -->
	<!-- <CookieBanner /> -->
	<!-- COOKIE - fin -->
</div>
